import { createContext } from "react";
export var AppContext = createContext(null);
//# sourceMappingURL=context.js.map